import React, { ReactNode } from "react";

export function ParlorHeadSection({ component }: { component: ReactNode }) {
  return <>{component}</>;
}
